// AuthLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen w-full bg-light-surface dark:bg-dark-surface">
      <div className="min-h-screen flex items-center justify-center">
        <Outlet />
      </div>
    </div>
  );
}
